<app-complex-modal-template
    [canClose]="false"
    [isConfirmationMode]="false"
    [title]="title()">
    <ng-container>
        @if (hasError()) {
            <p [class.text-error]="hasError()">
                {{ message() }}
            </p>
        }
        <app-loading
            [customMessage]="message()"
            [hasMessage]="!hasError()" />
    </ng-container>
</app-complex-modal-template>
